import Urls from "../Urls";
import { axiosInstance } from "./AxiosInstance";
class DashboardReq {
  Profile = () => {
    return axiosInstance({
      method: "get",
      url: Urls.TeacherDashboardProfile(),
      // headers: {
      //     'Authorization': 'Bearer ' + LocalToken.Get('tokenObj').accToken
      // }
    });
  };
  SessionStats = (role) => {
    return axiosInstance({
      url: Urls.SessionStats(role),
      method: "get",
    });
  };
  UpcommingSession = (role) => {
    return axiosInstance({
      url: Urls.UpcommingSession(role),
      method: "get",
    });
  };
  GetSession = (role, params) => {
    return axiosInstance({
      method: "get",
      url: Urls.Session(role),
      params,
    });
  };
  GetSessionWithStatus = (role, params) => {
    return axiosInstance({
      method: "get",
      url: Urls.Session(role),
      params,
    });
  };
  LoadMoreLesson = (params, role) => {
    return axiosInstance({
      method: "get",
      url: Urls.Session(role),
      params,
    });
  };
  SearchSession = (params, role) => {
    return axiosInstance({
      method: "get",
      url: Urls.Session(role),
      params,
    });
  };
  GetWallet = (role) => {
    return axiosInstance({
      method: "get",
      url: Urls.Wallet(),
      // headers: {
      //     'Authorization': 'Bearer ' + LocalToken.Get('tokenObj').accToken
      // }
    });
  };
  GetWalletHistory = (role) => {
    return axiosInstance({
      method: "get",
      url: Urls.WalletHistory(),
      // headers: {
      //     'Authorization': 'Bearer ' + LocalToken.Get('tokenObj').accToken
      // }
    });
  };
  IncomeStats = (role) => {
    return axiosInstance({
      method: "get",
      url: Urls.IncomeStats(),
      // headers: {
      //     'Authorization': 'Bearer ' + LocalToken.Get('tokenObj').accToken
      // }
    });
  };
  SessionJoin = (SessionID) => {
    return axiosInstance({
      method: "get",
      url: Urls.SessionJoin(SessionID),
      // headers: {
      //     'Authorization': 'Bearer ' + LocalToken.Get('tokenObj').accToken
      // }
    });
  };
  UserReview = (SessionID, data) => {
    return axiosInstance({
      method: "post",
      url: Urls.UserReview(SessionID),
      data,
    });
  };
  LingoReview = (SessionID, data) => {
    return axiosInstance({
      method: "post",
      url: Urls.LingoReview(SessionID),
      data,
    });
  };
  Schedule = (id, data) => {
    return axiosInstance({
      url: Urls.Schedule(id),
      method: "PATCH",
      data,
    });
  };
  DemoClass = () => {
    return axiosInstance({
      method: "GET",
      url: Urls.DemoClass(),
    });
  };
  ReviewStats = (id) => {
    return axiosInstance({
      method: "GET",
      url: Urls.ReviewStats(id),
    });
  };
  lastSessionWithoutReview = () => {
    return axiosInstance({
      method: "GET",
      url: Urls.LastSessionWithoutReview(),
    });
  };
  calendars = () => {
    return axiosInstance({
      method: "GET",
      url: Urls.Calendars(),
    });
  };
  suspendClassByTeacher = (id, data) => {
    return axiosInstance({
      method: "PATCH",
      url: Urls.TeacherSuspendSession(id),
      data,
    });
  };
  scheduleSessionByTeacher = (id, data) => {
    return axiosInstance({
      method: "PATCH",
      url: Urls.TeacherScheduleSession(id),
      data,
    });
  };
  rescheduleSessionByTeacher = (id, data) => {
    return axiosInstance({
      method: "PATCH",
      url: Urls.TeacherRescheduleSession(id),
      data,
    });
  };
}
export default new DashboardReq();
